<template>
  <div class="dropdown more-btn-dropdown" v-bind:class="classBindings">
    <button class="btn rounded-circle menu-toggle" v-on:click="toggleMenu"></button>
    <div class="dropdown-menu dropdown-menu-right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import clickout from '../mixins/clickout';

  export default {
    name: 'more-btn-dropdown',

    mixins: [
      clickout,
    ],

    props: {
      dropup: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        visible: false,
      };
    },

    computed: {
      classBindings() {
        return {
          show: this.visible,
          dropup: this.dropup,
        };
      },
    },

    watch: {
      visible(state, old) {
        if (state === old) {
          // Avoid duplicated emits
          return;
        }

        if (state) {
          this.$root.$emit('shown::dropdown', this);
        } else {
          this.$root.$emit('hidden::dropdown', this);
        }
      },
    },

    methods: {
      toggleMenu() {
        this.visible = !this.visible;
      },

      clickOutListener() {
        this.visible = false;
      },

      click() {
        this.toggleMenu();
      },
    },

    created() {
      this.$root.$on('shown::dropdown', (el) => {
        if (el !== this) {
          this.visible = false;
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/MoreBtnDropdown.vue